<template>
  <v-card class="purchase-choice" max-width="768" tile>
    <v-card-title class="justify-end px-3 py-2">
      <a @click="closeDialog()" id="btn__TlDB4btZZ0225cLzluzAPw==">
        <v-icon large> mdi-close </v-icon>
      </a>
    </v-card-title>
    <v-card-text class="text-center px-4">
      <v-row cols="12" class="mt-2 mb-8" no-gutters>
        <v-col cols="12">
          <p class="mb-5 font--m-3">
            사입비 외상 품목을 <br />
            확인해주세요.
          </p>
        </v-col>
        <v-col cols="12">
          <div class="logo-circle">
            <LogoImage />
          </div>
        </v-col>
      </v-row>

      <v-row class="text-center" no-gutters>
        <v-col cols="12">
          <v-card class="credit-purchase-card">
            <v-row no-gutters class="text-center">
              <v-col cols="4">
                <p class="font--m-4 mb-3">사입 거래처</p>
                <p class="font--m-4 color--buynow mb-0">
                  {{ Object.keys(wholesalers).length | commaFormat }}
                </p>
              </v-col>
              <v-col cols="4">
                <p class="font--m-4 mb-3">사입 품목</p>
                <p class="font--m-4 color--buynow mb-0">
                  {{ totalItem | commaFormat }}
                </p>
              </v-col>
              <v-col cols="4">
                <p class="font--m-4 mb-3">사입 수량</p>
                <p class="font--m-4 color--buynow mb-0">
                  {{ totalEa | commaFormat }}
                </p>
              </v-col>
            </v-row>
            <v-row no-gutters class="text-center">
              <v-col cols="12">
                <v-divider class="my-5"></v-divider>
              </v-col>
              <v-col cols="6">
                <p class="font--m-4 mb-0">총 사입비 외상 금액</p>
              </v-col>
              <v-col cols="6">
                <p class="font--m-4 color--buynow mb-0">
                  {{ totalAmount | commaFormat }}
                  <span class="color--black font--m-5">원</span>
                </p>
              </v-col>
            </v-row>
            <v-row v-if="isDisabled" no-gutters class="text-center">
              <v-col cols="12">
                <v-divider class="my-5"></v-divider>
              </v-col>
              <v-col cols="6">
                <p class="font--m-4 mb-0">정보 미입력 주문</p>
              </v-col>
              <v-col cols="6">
                <p class="font--m-4 color--pinkred-110 mb-0">
                  {{ invalidList.length | commaFormat }}
                </p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12" class="mt-5">
          <BasicButton :disabled="isDisabled" @click="clickSubmit()">사입비 신청하기</BasicButton>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    uuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      pickedDate: null,
      origin: null,
      invalidList: [],
      wholesalers: {},
      products: [],
      creditApplyDialog: false,
    }
  },
  computed: {
    totalItem() {
      return this.products.length
    },
    totalEa() {
      let ea = 0
      this.products.forEach((p) => {
        ea += p.quantity
      })
      return ea
    },
    totalAmount() {
      let amt = 0
      this.products.forEach((p) => {
        amt += p.getTotalAmount()
      })
      return amt
    },
    isDisabled() {
      return this.invalidList.length > 0
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('overlay', {
      closeDialog: 'closeOverlay',
    }),
    ...mapActions('product', ['getProductsDetail', 'confirmPurchases', 'confirmCredits']),
    async fetchData() {
      this.isLoading = true
      const data = await this.getProductsDetail(this.uuid)
      this.origin = data
      const validList = []
      const invalidList = []

      data.itemSet.forEach(async (item) => {
        if (item.isValid() === true) {
          const wholesalerId = item.wholesaler.uuid

          if (this.wholesalers[wholesalerId]) {
            this.wholesalers[wholesalerId].items.push(item)
          } else {
            const temp = {
              ...item?.wholesalers,
              items: [item],
            }

            this.wholesalers[wholesalerId] = temp
          }
          validList.push(item)
        } else {
          invalidList.push(item)
        }
      })

      this.pickedDate = data.date
      this.products = validList
      this.invalidList = invalidList

      this.isLoading = false
    },
    async confirmPurchase(purchase) {
      this.purchase = await this.confirmPurchases(this.origin.uuid)
      this.$router.push(`/purchases/${purchase.uuid}/complete`)
    },
    async confirmCredit() {
      this.isLoading = true
      try {
        const credit = await this.confirmCredits(this.origin.uuid)
        this.$router.push(`/credits/${credit.uuid}/complete`)
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async clickSubmit() {
      if (this.isDisabled) {
        return
      }
      const confirm = await this.$swal.basic.confirm({
        html: `
        <p class="font--m-3 mb-0">
          총 외상금액 <br /><span class="color--buynow font--m-3">
            ${this.$options.filters.commaFormat(this.totalAmount)}
          </span> 원을 외상 신청합니다
        </p>
        `,
      })
      // 확인 눌렀을 때, 다음 페이지로 넘어감
      if (confirm.isConfirmed === true) {
        this.confirmCredit()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.purchase-choice {
  height: 100%;
  overflow: hidden;
}

.logo-circle {
  width: 60px;
  height: 60px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 100%;
  box-shadow: 3px 5px 12px rgb(189, 189, 189, 0.8);

  margin: 0 auto;
}

.credit-purchase-card {
  padding: 2rem 16px;
}
</style>
